import { CardContent } from '@/components/Card'
import { Button } from '@/components/Button'
import {
  DropdownItem,
  DropdownItemTitle,
  DropdownTitle,
} from '@/components/Dropdown'
import { NextStepCardMore } from '@/features/jobs/details/components/NextStepCard'
import styles from './TaxExtensionProgressionActions.module.css'

export interface TaxExtensionProgressionActionsProps {
  /**
   * If an outside button of this component is primary, use this prop to
   * prevent having two primary buttons.
   */
  isSecondary?: boolean
  isPersonalExtensionAvailable: boolean
  isBusinessExtensionAvailable: boolean
  isOutsourcingExtensionAvailable: boolean
  onBeginPersonalExtension: () => unknown
  onBeginBusinessExtension: () => unknown
  onPlaceJobOnExtension: () => unknown
}

export function TaxExtensionProgressionActions({
  isSecondary,
  isPersonalExtensionAvailable,
  isBusinessExtensionAvailable,
  isOutsourcingExtensionAvailable,
  onBeginPersonalExtension,
  onBeginBusinessExtension,
  onPlaceJobOnExtension,
}: TaxExtensionProgressionActionsProps) {
  return (
    <CardContent>
      <div className={styles.cardContainer}>
        {isPersonalExtensionAvailable && (
          <Button
            label="Begin Personal Extension"
            variant={isSecondary ? 'secondary' : 'primary'}
            size="wide-slim"
            onPress={onBeginPersonalExtension}
            testId="job-progression-start-personal-extension-button"
          />
        )}

        {isBusinessExtensionAvailable && (
          <Button
            label="Begin Business Extension"
            variant={
              isSecondary || isPersonalExtensionAvailable
                ? 'secondary'
                : 'primary'
            }
            size="wide-slim"
            onPress={onBeginBusinessExtension}
            testId="job-progression-start-business-extension-button"
          />
        )}

        {isOutsourcingExtensionAvailable && (
          <Button
            label="Place Job On Extension"
            variant={isSecondary ? 'secondary' : 'primary'}
            size="wide-slim"
            onPress={onPlaceJobOnExtension}
            testId="job-progression-start-outsourcing-extension-button"
          />
        )}
      </div>
    </CardContent>
  )
}

/**
 * The extension actions as a menu, for when they sit beside the step's main
 * action.
 */
export function TaxExtensionProgressionMenu({
  isPersonalExtensionAvailable,
  isBusinessExtensionAvailable,
  isOutsourcingExtensionAvailable,
  onBeginPersonalExtension,
  onBeginBusinessExtension,
  onPlaceJobOnExtension,
}: TaxExtensionProgressionActionsProps) {
  return (
    <NextStepCardMore testId="job-progression-extension-menu">
      <DropdownTitle>Extension</DropdownTitle>
      {isPersonalExtensionAvailable && (
        <DropdownItem
          onPress={onBeginPersonalExtension}
          testId="job-progression-start-personal-extension-button"
        >
          <DropdownItemTitle>Begin Personal Extension</DropdownItemTitle>
        </DropdownItem>
      )}
      {isBusinessExtensionAvailable && (
        <DropdownItem
          onPress={onBeginBusinessExtension}
          testId="job-progression-start-business-extension-button"
        >
          <DropdownItemTitle>Begin Business Extension</DropdownItemTitle>
        </DropdownItem>
      )}
      {isOutsourcingExtensionAvailable && (
        <DropdownItem
          onPress={onPlaceJobOnExtension}
          testId="job-progression-start-outsourcing-extension-button"
        >
          <DropdownItemTitle>Place Job On Extension</DropdownItemTitle>
        </DropdownItem>
      )}
    </NextStepCardMore>
  )
}
